import * as React from "react";
import { forwardRef } from "react";
const SvgDatabase = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-database-icon lucide-database", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("ellipse", { cx: 12, cy: 5, rx: 9, ry: 3 }), /* @__PURE__ */ React.createElement("path", { d: "M3 5V19A9 3 0 0 0 21 19V5" }), /* @__PURE__ */ React.createElement("path", { d: "M3 12A9 3 0 0 0 21 12" }));
const ForwardRef = forwardRef(SvgDatabase);
export default ForwardRef;
